module.exports = __webpack_public_path__ + "KaTeX_SansSerif-Regular.5660f1b6.woff";